module.exports = __webpack_public_path__ + "img/add-grey.87774f8c.svg";